import Headroom from 'headroom.js';

function Header({ node }) {
	const options = {
		offset: 0,
		tolerance: {
			up: 5,
			down: 0,
		},
	};

	const headroom = new Headroom(node, options);

	headroom.init();

	log(headroom);

	return () => {};
}

export default Header;
